"use client"
import React, {createContext, useState} from "react";
import {userType} from "@/app/types/userTypes";

const useUserState = () => useState<userType>({
    userId: '',
    username: 'string',
    password: 'string'
});

export const UserContext = createContext<ReturnType<
    typeof useUserState
> | null>(null);

export const useUser = () => {
    const user = React.useContext(UserContext);
    if (!user) {
        throw new Error("useUser must be used within a UserProvider");
    }
    return user;
};

const UserProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = useUserState();

    return (
        <UserContext.Provider value={[user, setUser]}>
            {children}
        </UserContext.Provider>
    );
};

export default UserProvider;
